export const API      = 'https://kobn1d6zn5.execute-api.us-east-1.amazonaws.com/prod';
export const USDA_KEY = 'YeP89pyOFlRSoFLANk4Rf28mDK90KW8UKV0E4ZBB';
export const GROQ_KEY = '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';
export const STRIPE_PUB_KEY  = 'pk_live_51TJ4C5Rx7XU06jqLvVn3kU1Asd1DcSZkT2lTS2Pz4WdP5fTgq5bWhyth4vhYUkQkMXe1SMPMlUwX5yWB83W7qoPU00N2KbURKs';